import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { commandsActions } from '@src/store/reducers/commandsReducer';

export const createCommandsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [commandsActions.GET_COMMANDS]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Automation/Commands`;
            const response = await http.get(url);
            const list = response.data;
            list.commandLineScript = '';
            next({ type: commandsActions.SET_COMMANDS, payload: list });
            return list;
        },
        [commandsActions.GET_COMMAND_PROPERTIES]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Automation/Command/${payload.commandName}`;
            const response = await http.get(url);
            const data = response.data;
            next({
                type: commandsActions.SET_COMMAND_PROPERTIES,
                payload: {
                    commands: payload.commands,
                    selectedCommandFields : data,
                    selectedCommandName: payload.commandName,
                    commandLineScript: ''
                }
            });
            return data;
        },
        [commandsActions.GET_GENERATE_SCRIPT]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Automation/Command/${payload.commandName}/Script`;
            const response = await http.post(url, payload.params);
            const data = response.data;
            next({ type: commandsActions.SET_GENERATE_SCRIPT, payload: { commandLineScript: data, } });
            return data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/commands.middleware.ts